import { parsePromotionDate } from '../../../utils/promotionCountdown';

const LOCALES: Record<string, string> = {
  ru: 'ru-RU',
  uz: 'uz-Latn-UZ',
  en: 'en-US',
};

/** «8 октября» для подписи «До 8 октября»; null — даты нет или она кривая. */
export const formatPromoValidUntil = (
  endDate: string | null | undefined,
  language: string
) => {
  const time = parsePromotionDate(endDate);
  if (time === null) return null;

  const locale = LOCALES[language.slice(0, 2)] ?? LOCALES.ru;

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
  }).format(new Date(time));
};
